var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-checkbox" },
    _vm._l(_vm.options, function(result, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "form-check form-check-inline",
          class:
            _vm.value &&
            _vm.value
              .toString()
              .split(",")
              .includes(_vm.multiple == true ? result.id.toString() : "1")
              ? "checked"
              : ""
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.current_value,
                expression: "current_value"
              }
            ],
            ref: _vm.multiple == true ? "checkbox_" + index : "chechbox",
            refInFor: true,
            staticClass: "form-check-input",
            attrs: {
              type: "checkbox",
              name: _vm.multiple == true ? _vm.name + "[]" : result.id,
              id: _vm.multiple == true ? _vm.name + "_" + index : result.id
            },
            domProps: {
              value: _vm.multiple == true ? result.id : 1,
              checked: Array.isArray(_vm.current_value)
                ? _vm._i(
                    _vm.current_value,
                    _vm.multiple == true ? result.id : 1
                  ) > -1
                : _vm.current_value
            },
            on: {
              input: _vm.onInput,
              change: function($event) {
                var $$a = _vm.current_value,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = _vm.multiple == true ? result.id : 1,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.current_value = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.current_value = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.current_value = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form-check-label",
              attrs: {
                for: _vm.multiple == true ? _vm.name + "_" + index : result.id
              }
            },
            [
              !result.name.img
                ? [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("capitalize")(result.name)) +
                        "\n            "
                    )
                  ]
                : [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("capitalize")(result.name.text)) +
                        "\n                "
                    ),
                    _c("masked-image", { attrs: { src: result.name.img } })
                  ]
            ],
            2
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }